import React from 'react';
import PaginaContato from './PaginaContato';
import TabelaAplicaProduto from './TabelaAplicaProduto';

function DetalhesContatos(props) {

const produto = props?.props;

console.log("MODAL111", props);


  return (
    <>
      <br />
      <PaginaContato props={produto} /> 
      {/* <br />
      <TabelaAplicaProduto codigo={produto.codigo} />
      <br />  */}
    </>
  )
}

export default DetalhesContatos